
class Application {
    get dataStore() {
        return this._dataStore;
    }

    set dataStore(value) {
        this._dataStore = value;
    }

    constructor() {
    }
}


module.exports = new Application();
